"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
require("./GoodCarousel.css");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useWindowWidth = () => {
  const [width, setWidth] = (0, _react.useState)(0);
  (0, _react.useLayoutEffect)(() => {
    const updateWidth = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateWidth);
    updateWidth();
    return () => window.removeEventListener('resize', updateWidth);
  }, []);
  return width;
};
const GoodCarousel = _ref => {
  let {
    children,
    currentPane = 0,
    itemsPerPane = 3,
    gap = 8,
    itemPeek = 40,
    animationDuration = 0.4,
    onRender = null
  } = _ref;
  const windowWidth = useWindowWidth();
  const containerRef = (0, _react.useRef)(null);
  const containerInnerRef = (0, _react.useRef)(null);
  const [containerStyle, setContainerStyle] = (0, _react.useState)({});
  const [containerInnerStyle, setContainerInnerStyle] = (0, _react.useState)({});
  const [itemStyle, setItemStyle] = (0, _react.useState)({});
  const render = () => {
    const containerWidth = containerRef.current.offsetWidth;
    const itemCount = children.length;
    const paneCount = Math.ceil(itemCount / itemsPerPane);
    let currentPaneAdj = currentPane;
    if (currentPaneAdj < 0) {
      currentPaneAdj = paneCount - 1;
    } else if (currentPaneAdj > paneCount - 1) {
      currentPaneAdj = 0;
    }
    const gapCount = currentPaneAdj === 0 || currentPaneAdj === paneCount - 1 ? itemsPerPane : itemsPerPane + 1;
    const sliverCount = currentPaneAdj === 0 || currentPaneAdj === paneCount - 1 ? 1 : 2;
    const containerAdjustedWidth = containerWidth - (gap * gapCount + itemPeek * sliverCount);
    let sliverAdjust;
    if (currentPaneAdj === 0) {
      sliverAdjust = 0;
    } else if (currentPaneAdj === paneCount - 1) {
      sliverAdjust = gap + paneCount * itemPeek;
    } else {
      sliverAdjust = (currentPaneAdj + 1) * gap + 3 * itemPeek + (currentPaneAdj - 1) * (2 * itemPeek);
    }
    const itemWidth = containerAdjustedWidth / itemsPerPane;
    setContainerInnerStyle({
      gap: "".concat(gap, "px"),
      left: "".concat(-containerWidth * currentPaneAdj + sliverAdjust, "px"),
      transition: "left ".concat(animationDuration, "s")
    });
    setItemStyle({
      width: "".concat(itemWidth, "px"),
      transition: "width ".concat(animationDuration, "s")
    });
    setContainerStyle({
      height: "".concat(containerInnerRef.current.offsetHeight, "px")
    });
    if (onRender) {
      onRender({
        paneCount,
        currentPane: currentPaneAdj
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (!containerRef.current || !containerInnerRef.current || !windowWidth) {
      return;
    }
    render();
  }, [children, currentPane, itemsPerPane, gap, itemPeek, containerRef.current, containerInnerRef.current, windowWidth]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "GoodCarousel",
    ref: containerRef,
    style: containerStyle,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "GoodCarousel-inner",
      ref: containerInnerRef,
      style: containerInnerStyle,
      children: children.map((child, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "GoodCarousel-item",
        style: itemStyle,
        children: child
      }, index))
    })
  });
};
var _default = GoodCarousel;
exports.default = _default;